import React, {useContext} from 'react';
import {UserDetailsContext} from "../Contexts/contexts";

export function withUserDetails(Component) {
    return function (props) {
        const userProps = useContext(UserDetailsContext);
        return <Component {...userProps} {...props}/>
    }
}